module.exports = __webpack_public_path__ + "static/media/18.98422bc5.png";